import { useContext } from "react";

import { DispatchContext, DispatchToolbars, State, StateContext, ToolbarButtonEntry, ToolbarEntry } from "./reducer";

export function useToolbarsState(): State {
    const context = useContext(StateContext);
    return context;
}

export function useDispatchToolbars(): DispatchToolbars {
    const context = useContext(DispatchContext);
    if (context === undefined) {
        throw new Error("useDispatchToolbars must be used within a ToolbarProvider");
    }
    return context;
}

export function useToolbar(toolbarId: string): ToolbarEntry | undefined {
    const state = useToolbarsState();
    return state[toolbarId];
}

export function useToolbarButtons(toolbarId: string): ToolbarButtonEntry[] {
    const toolbar = useToolbar(toolbarId);
    if (!toolbar) {
        return [];
    }

    return toolbar.order
        .map((buttonId) => toolbar.buttons[buttonId])
        .filter((button) => button && button.state.visible);
}

export function useToolbarButtonOrder() {
    const state = useToolbarsState();

    return (toolbarId: string): string[] => {
        const toolbar = state[toolbarId];
        if (!toolbar) {
            throw new Error(`Toolbar "${toolbarId}" does not exist`);
        }
        return [...toolbar.order]; // Return a copy to prevent external mutations
    };
}
